import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { ModalContext } from '@/utils/contexts/ModalContext';

import Spinner from '@/views/components/Spinner/Spinner';

import api from '@/services/api';

import styles from '@/views/components/Modal/ModalDelete.module.scss';

const ModalContinueSimplification = () => {
	const { dict } = useSelector((state) => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);
	const navigate = useNavigate();

	const { closeModal, 
		modalAdditionalInfo: { id },
	} = useContext(ModalContext);

	const continueSimplificationAction = async () => {
		setRequestIsPending(true);
		api.put(`/letters/${id}/simplified`).then(() => {
			closeModal();
			navigate(0);
			setRequestIsPending(false);
		});
	};

	return (
		<div className='modal__content modal__delete-file'>
			{ requestIsPending && (
				<div className='letter__edit-metadata--spinner'>
					<Spinner />
				</div>
			) }
			<div className={ styles['delete'] }>
				<h3 className={ styles['delete--title'] }>
					{ dict.modals.continueSimplification.head }
				</h3>

				<div className={ styles['delete--comment'] }>
					<p>{ dict.modals.continueSimplification.text }</p>
				</div>

				<section className={ styles['delete--buttons'] }>
					<div
						className='button__std'
						onClick={
							closeModal
						}
					>
						{dict.cancel}
					</div>
					<div
						className='button__blue'
						onClick={ continueSimplificationAction }
					>
						{ dict.modals.continueSimplification.button }
					</div>
				</section>
			</div>
		</div>
	);
};

export default ModalContinueSimplification;